"use client";

import { Progress, ProgressColor } from "@workspace/ui/components";
import { notFound, useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";

import { ProductView } from "@/components";
import { useCategory } from "@/context";

export default function ProductPage({
  params,
}: {
  params: Promise<{ productSlug: string }>;
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRenderProductView, setShouldRenderProductView] = useState(false);
  const [notFoundSelected, setNotFoundSelected] = useState(false);
  const router = useRouter();
  const { getProductData } = useCategory();

  useEffect(() => {
    const handleProductSlug = async () => {
      try {
        const resolvedParams = await params;
        const slug = resolvedParams.productSlug;

        console.log("Product slug:", slug);

        // Regex dla formatów MA-1Y-014 lub MA-1Y
        const slugRegex = /^[A-Z]{2}-[A-Z0-9]{2}(-\d{3})?$/;

        if (!slugRegex.test(slug)) {
          setNotFoundSelected(true);
          return;
        }

        // Pobierz dane produktu
        const productData = await getProductData(slug);

        if (!productData) {
          console.error("Product data not found for reference:", slug);
          setNotFoundSelected(true);
          return;
        }

        console.log("Product data loaded:", productData);

        // Sprawdź czy slug już jest w poprawnym formacie URL
        // Jeśli to tylko reference (np. MA-1Y), przekieruj na pełny URL
        if (productData.parentCategory.linkRewrite && productData.url) {
          setShouldRenderProductView(true);
          // Przekieruj na właściwy URL produktu na podstawie pobranych danych
          // Format: /kategoria/link-rewrite z pierwszym dostępnym wariantem
          const properUrl = `/${productData.parentCategory.linkRewrite}/${productData.url}`;

          console.log("Redirecting to:", properUrl);
          router.push(properUrl);
        }
      } catch (error) {
        console.error("Error handling product slug:", error);
        notFound();
      } finally {
        setIsLoading(false);
      }
    };

    handleProductSlug();
  }, [params, router, getProductData]);

  if (notFoundSelected) {
    notFound();
  }

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Progress color={ProgressColor.GRAYSCALE_400} />
      </div>
    );
  }

  if (shouldRenderProductView) {
    return <ProductView params={params} />;
  }

  // Jeśli przekierowujemy, nie renderujemy nic
  return null;
}
